import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { forgotPassword } from '../networking/auth/auth';
import { useNavigate } from 'react-router-dom';
import { Container, TextField, Button, Typography, Box, Paper, Avatar } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      navigate('/');
    } catch (error) {
      console.error("Failed to log in", error);
    }
  };

  // const handleSignUp = () => {
  //   navigate('/signup'); // Assuming you have a signup page to navigate to
  // };

  // Handle forgot password functionality
  const handleForgotPassword = async () => {
    if (!email.trim()) {
      alert('Please enter your email to reset your password.');
      return;
    }

    try {
      await forgotPassword(email);
      alert('Password reset email sent. Please check your inbox.');
    } catch (error) {
      console.error("Error sending password reset email:", error);
      alert('Failed to send password reset email. Please try again.');
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Paper elevation={3} sx={{ p: 4, mt: 8, backgroundColor: '#f5f5f5' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: '#00274D' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5" sx={{ color: '#00274D' }}>
            Sign in
          </Typography>
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, backgroundColor: '#00274D', color: '#fff' }}
            >
              Sign In
            </Button>
            <Button
              fullWidth
              variant="outlined"
              sx={{ borderColor: '#00274D', color: '#00274D' }}
              onClick={handleForgotPassword} // Call the forgot password handler
            >
              Forgot Password
            </Button>
            {/* <Button
              fullWidth
              variant="outlined"
              sx={{ borderColor: '#00274D', color: '#00274D' }}
              onClick={handleSignUp}
            >
              Sign Up
            </Button> */}
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default Login;